import { analysisPermissionsAndOr } from "./auth";
export default (app: any) => {
  app.directive('permissions', (el: any, e: any) => {
    analysisPermissionsAndOr(e.value) || el.remove();
  })
};